import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, Subject, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  apiUrl = environment.API_URL;

  constructor(private http : HttpClient) { }

  getStates(): Observable<any> {
    var url = this.apiUrl + "/state";

    return this.http.get(url);
  }

  getCities(state?: any): Observable<any> {
    var url = this.apiUrl + "/city";
    if(state)
      url += '?state=' + state;

    return this.http.get(url);
  }
}
